import React from "react";
import { useState,useEffect,useMemo } from "react";

import ListTable from "../utils/Table";
import { all_watchhour_list } from './../../actions/watchhour';
import { useDispatch,useSelector } from 'react-redux';
import Export from "./../utils/Export"
export default function Watchhour() {
	const dispatch=useDispatch()
	const [tableData, setTableData] = useState({
		tableTitle: "Watchhours",
		disableDelete:true,
		tableHead: [
			{
				id: "name",
				label: "Name",
			},
			{
				id: "image",
				label: "Image",
				isImage:true
			},
			{
				id: "category_type",
				label: "Content Type",
				padding:"8px 20px"
			},
			{
				id: "watch_hours",
				label: "Watch Hours",
			},
			
			{
				id: "views",
				label: "Views",
			},
			
			{
				id: "plan_detail",
				label: "Plan",
			},
		],
		tableBody: [
			
		],filterColumn:[
			{
				id: "1",
			title: "Select Plan",
			name: "plan_detail",
			options: ["FREE", "TVOD","SVOD"],
			},
			{
				id: "2",
			title: "Select Content Type",
			name: "category_type",
			options: ["Movie", "Episode"],
			}
		]
	});

	
    const watchhours = useSelector((state) => state.watchhours.watchhours);
    useEffect(()=>{
      dispatch(all_watchhour_list())
    },[])
    useMemo(()=>{
      
      if(watchhours?.statuscode==200){const temp=tableData
      temp.tableBody=watchhours?.data
      setTableData({...temp})}
    },[watchhours])
	

	
	
	return (
		<>
		
			

		<Export fileName={"Watch Hours"}  exportData={tableData?.exportData||tableData?.tableBody} headings={tableData.tableHead.map((value)=>value.label)}/>
		
	
				<ListTable
					tableData={tableData}
					key={"ListTable"}
					setTableData={setTableData}
					
				/>
		
		</>
	);
}
